<!-- アクションボタン群 -->

<div class="clearfix padding-top-bottom-5 action-area">
  <!-- 左側部分 -->
  <div class="tab">
    <!-- メインパート以外も表示 -->
    <div class="tab-cell cellForShowOtherThanMainInfo">
      <app-main-part-button [showOnlyMainPart]="mailInfo.showOtherThanImportantLine"
        (click)="changeShowOnlyImportantLine(mailInfo)">
      </app-main-part-button>
    </div>

    <!-- スキルシートボタン(オンラインで見る・スキルシートDL) -->
    <ng-container *ngFor="let attached_file of workerMail?.attached_files; last as last">
      <div *ngIf="mailType==='worker' && workerMail?.rawdata_url && last" class="tab-cell">
        <app-skill-sheet-button [workerMail]="mailType==='worker'?mailInfo:null"
          [projectMail]="mailType==='worker'? null : mailInfo" [page]="page">
        </app-skill-sheet-button>
      </div>
    </ng-container>

    <!-- メモボタン -->
    <div *ngIf="page===offerPage;else singleMemo" class="tab-cell">
      <app-memo [offer]="offer" [worker]="workerMail" [project]="projectMail"></app-memo>
    </div>
    <ng-template #singleMemo>
      <div *ngIf="mailType==='project'" class="tab-cell">
        <app-memo [project]="mailInfo"></app-memo>
      </div>
      <div *ngIf="mailType==='worker'" class="tab-cell">
        <app-memo [worker]="mailInfo"></app-memo>
      </div>
    </ng-template>

    <!-- 問い合わせメール送信ボタン -->
    <div class="tab-cell">
      <app-detail-email-reply [mailInfo]="mailInfo" [mailType]="mailType"></app-detail-email-reply>
    </div>

    <!-- ファイルダウンロードボタン -->
    <div *ngIf="workerMail?.rawdata_url || projectMail?.rawdata_url" class="tab-cell">
      <app-file-download-button
        [workerMail]="mailType==='worker'? mailInfo : null"
        [projectMail]="mailType==='worker'? null : mailInfo"
        [page]="page">
      </app-file-download-button>
    </div>

    <!-- メール情報修正ボタン -->
    <div class="tab-cell">
      <app-edit-mail-info-button [mailInfo]="mailInfo" (correctMail)="onCorrectMail()">
      </app-edit-mail-info-button>
    </div>

    <!-- エラー報告ボタン -->
    <div class="tab-cell">
      <app-error-feed-back-button [mailInfo]="mailInfo" [mailType]="mailType" [page]="page"
        [matchingScoreId]="mailInfo.matching_score?.id" (deleted)="onDeletedMail()"
        (correctMail)="onCorrectMail()">
      </app-error-feed-back-button>
    </div>
  </div>

  <!-- 右側部分 -->
  <div class="expand-space" [ngSwitch]="page">
    <ng-container *ngSwitchCase="offerPage">
      <!-- ステータス変更ボタン -->
      <app-matching-button [offerId]="offer.id" [side]="mailType"
        [matchingOffer]="offer" [orderFinished]="mailInfo.order_finished" [projectAIMailId]="projectMail.ai_mail_id"
        [actionLogForOffer]="actionLogForOffer" [workerAIMailId]="workerMail.ai_mail_id"
        (changeStatus)="changeStatus.emit($event)">
      </app-matching-button>

    </ng-container>
    <ng-container *ngSwitchCase="workerListPage">
      <app-other-candidate-button [workerMail]="workerMail" [projectMail]="projectMail" [baseMailType]="mailType"
        [fromListPage]="true">
      </app-other-candidate-button>
    </ng-container>
    <ng-container *ngSwitchCase="projectListPage">
      <app-other-candidate-button [workerMail]="workerMail" [projectMail]="projectMail" [baseMailType]="mailType"
        [fromListPage]="true">
      </app-other-candidate-button>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <!-- ステータス変更ボタン -->
      <ng-container *ngIf="pairMail">
        <app-offer-button [workerMail]="workerMail" [projectMail]="projectMail" [offerPage]="page" [result]="result"
          [actionLogId]="actionLogId" [offerType]="mailType"></app-offer-button>

        <div class="feedback-button">
          <app-pair-suitability-feedback-button
            [workerMailAiId]="workerMail.ai_mail_id"
            [projectMailAiId]="projectMail.ai_mail_id"
            [page]="page">
          </app-pair-suitability-feedback-button>
        </div>
      </ng-container>
    </ng-container>
  </div>



</div>
